import styled from "styled-components";

export const PageContainer = styled.div`
  min-height: 100%;
  width: 100%;
  background-color: #ffffff;

  @media (max-width: 770px) {
    min-height: 100vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

export const DivisionChangeName = styled.div`
  width: 100%;
  margin-right: 3rem;

  @media (max-width: 770px) {
    margin: 0;
    padding-bottom: 4rem;
  }
`;

export const Content = styled.div`
  padding: 0.5rem 2rem 2rem 2rem;
  margin-left: 3rem;

  @media (max-width: 770px) {
    margin: 0;
    padding: 0.5rem 3.5rem 2rem 1rem;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;

  @media (max-width: 770px) {
    display: none;
  }
`;

export const HeaderMobileContainer = styled.div`
  width: 100%;
  background-color: white;

  @media (min-width: 770px) {
    display: none;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0;

  @media (max-width: 770px) {
    margin: 3rem 0 2rem 0;
  }
`;

export const ValeIcon = styled.img`
  width: 39px;
  height: 26px;
  margin-right: 20px;
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const BackIcon = styled.span`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  margin-right: 5rem;

  @media (max-width: 770px) {
    margin-right: 1rem;
  }
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2rem 0 1.5rem 0;
  width: 35%;

  label {
    font-size: 1rem;
    color: #808080;
    margin-bottom: 0.3rem;
  }

  @media (max-width: 770px) {
    width: 100%;
    margin-bottom: 1.2rem;

    label {
      font-size: 0.9rem;
    }
  }
`;

export const StyledInput = styled.input`
  border: 1px solid #b0b0b0;
  border-radius: 0.4rem;
  padding: 0.8rem;
  font-size: 1rem;
  box-shadow: 0px 2px 4px #00000066;

  @media (max-width: 770px) {
    font-size: 0.85rem;
  }
`;

export const FieldError = styled.span`
  color: #d32f2f;
  font-size: 0.9rem;
  margin-top: 0.4rem;
`;

export const DivisionButton = styled.div`
  margin-top: 2rem;
  width: 35%;

  @media (max-width: 770px) {
    width: 100%;
  }
`;

export const IconLoading = styled.i`
  font-size: 1.5rem;
`;

export const ModalErrorMessage = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #707070;
`;

export const RecaptchaWrapper = styled.div`
  margin: 1.5rem 0;

  @media (max-width: 360px) {
    transform: scale(0.92);
    transform-origin: left top;
  }

  @media (max-width: 320px) {
    transform: scale(0.85);
    transform-origin: left top;
  }
`;
